<template>
    <section class="used-search stand bottom-space">
        <div class="ink-grid">
            
            <nav class="ink-navigation">
                <ul class="breadcrumbs back negative">
                    <li>
                        <a :href="propReturnUrl">Voltar</a>
                    </li>
                </ul>
            </nav>

            <div class="column-group quarter-gutters heading">

                <div class="all-60 medium-50 small-100 tiny-100">
                    <h1 class="section-title">{{ propTitle }}</h1>
                </div>

                <div class="all-40 medium-50 small-100 tiny-100" v-if="propShowSearch">
                    <div class="control-group">
                        <div class="control append-button">
                            <span>
                                <input id="searchTerm" name="searchTerm" placeholder="Marca, Modelo..." type="text"
                                v-model="filter.SearchTerm" @keydown.enter.stop.prevent v-on:keyup.enter="onSearch" />
                            </span>
                            <button data-trackerlink="HP|PROCURARCARROUSADO|PESQUISAR" class="ink-button main-action toggleFilter" v-on:click="onSearch">Pesquisar</button>
                        </div>
                    </div>
                </div>

            </div>
                
        </div>
    </section>
</template>

<script>
import Filters from '../scripts/filters.js'
import confirmationmodal from '../shared/confirmation-modal.vue'
import loginmodal from '../shared/login-modal.vue';
import tagManager from '../scripts/tagManager';

export default {

    data() {
        return {
            filter: {
                BodyTypeId: [],
                BrandId: [],
                ModelId: [],
                VersionId: [],
                ColorId: [],
                CountyId: [],
                DistrictId: [],
                FuelId: [],
                TransmissionId: [],
                FromProfessional: [],
                IsNational: [],
                GridView: true,
                OrderBy: "",
                IsEmpty: true,
                YearStart: "",
                YearEnd: ""
            },
            brands: {},
            models: [],
            bodyTypes: [],
            fuels: [],
            transmissions: [],
            colors: [],
            districts: [],
            sources: [],
            advertiserTypes: [],
            isCollapsed: false,
            savedSearchesCount: 0,
            urlLogin: "/account/signin?url=" + window.location.href
        };
    },
    props: {
        propIsUsedVehicle: Boolean,
        propIsGridView: Boolean,
        propOrderBy: {
            type: Number,
            default: 0
        },
        propTitle: {
            type: String,
            default: "Procurar carros"
        },
        propReturnUrl: {
            type: String,
            default: "/carros-usados"
        },
        propShowSearch: {
            type: Boolean,
            default: true
        }       
    },
    components: {
        confirmationmodal,
        loginmodal
    },
    async beforeMount() {
        let queryString = window.location.search;
        let urlParams = new URLSearchParams(queryString);
        if (urlParams.has("b") && urlParams.get("b") != null){
            this.filter = {
                BodyTypeId: [],
                BrandId: [],
                ModelId: [],
                VersionId: [],
                ColorId: [],
                CountyId: [],
                DistrictId: [],
                FuelId: [],
                TransmissionId: [],
                FromProfessional: [],
                IsNational: [],
                IsEmpty: true,
                YearStart: "",
                YearEnd: "",
                GridView: this.filter.GridView,
                OrderBy: this.filter.OrderBy
            };
            this.filter.BrandId = [parseInt(urlParams.get("b"))];
        }
        if (urlParams.has("search-term")){
            this.filter.SearchTerm = urlParams.get("search-term");
        }

        this.propIsGridView = this.filter.GridView;
        this.propOrderBy = this.filter.OrderBy;
    },

    async mounted() {
        $(document).ready(function () {

            $('.selectpicker').selectpicker({
                noneResultsText: 'Sem resultados'
            });

            $('.toggleFilter').on('click', function (e) {
                $('.filters').toggleClass("hide-all");
                e.preventDefault();
            });
        });
    },
    

    async updated() {

        // refresh brands dropdown
        $('#BrandsDrop').selectpicker('refresh');
        $('#BrandsDrop').selectpicker('val', this.filter.BrandId);
        if (this.filter.BrandId.length > 0) $('#deselectBrands').show();

        // refresh models dropdown
        $('#ModelsDrop').selectpicker('refresh');
        $('#ModelsDrop').selectpicker('val', this.filter.ModelId);
        if (this.filter.ModelId.length > 0) $('#deselectModels').show();

        // refresh fuels dropdown
        $('#DropFuels').selectpicker('refresh');
        $('#DropFuels').selectpicker('val', this.filter.FuelId);

        // refresh BodyTypes dropdown
        $('#DropBodyTypes').selectpicker('refresh');
        $('#DropBodyTypes').selectpicker('val', this.filter.BodyTypeId);

        // refresh colors dropdown
        $('#DropColor').selectpicker('refresh');
        $('#DropColor').selectpicker('val', this.filter.ColorId);

        // refresh colors dropdown
        $('#DropTransmission').selectpicker('refresh');
        $('#DropTransmission').selectpicker('val', this.filter.TransmissionId);

        // refresh Districts dropdown
        $('#DropDistrict').selectpicker('refresh');
        $('#DropDistrict').selectpicker('val', this.filter.DistrictId);

        // refresh AdvrtiserTypes dropdown
        $('#DropSources').selectpicker('refresh');
        $('#DropSources').selectpicker('val', this.filter.IsNational);

        // refresh AdvrtiserTypes dropdown
        $('#DropAdvrtiserTypes').selectpicker('refresh');
        $('#DropAdvrtiserTypes').selectpicker('val', this.filter.FromProfessional);

    },

    methods: {
        
        async OnSearchLoaded(filter) {
            this.filter = filter;
            this.onSearch();
        },
        onSearch() {
            this.$emit('search-click', this.filter);
        },
        async updateSearch() {
            this.NormalizeFilter();
        },
        async onResetSearch() {
            this.filter = {
                BodyTypeId: [],
                BrandId: [],
                ModelId: [],
                VersionId: [],
                ColorId: [],
                CountyId: [],
                DistrictId: [],
                FuelId: [],
                TransmissionId: [],
                FromProfessional: [],
                IsNational: [],
                IsEmpty: true,
                YearStart: "",
                YearEnd: "",
                SearchTerm: "",
                GridView: this.filter.GridView,
                OrderBy: this.filter.OrderBy
            };
            this.$emit('clear-search', this.filter);
        },
        NormalizeFilter() {

            if (this.filter.YearStart != null && this.filter.YearStart == "") {
                this.filter.YearStart = null;
            }

            if (this.filter.YearEnd != null && this.filter.YearEnd == "") {
                this.filter.YearEnd = null;
            }

            if (this.filter.PriceStart != null && this.filter.PriceStart == "") {
                this.filter.PriceStart = null;
            }

            if (this.filter.PriceEnd != null && this.filter.PriceEnd == "") {
                this.filter.PriceEnd = null;
            }

            if (this.filter.KmStart != null && this.filter.KmStart == "") {
                this.filter.KmStart = null;
            }

            if (this.filter.KmEnd != null && this.filter.KmEnd == "") {
                this.filter.KmEnd = null;
            }

            this.filter.GridView = this.propIsGridView;
            this.filter.OrderBy = this.propOrderBy;
        },
        // gets the name of "ids" provided that are inside "elements"
        retrieveNamesByIds(elements, ids) {
            if (!elements || !Array.isArray(elements) || !ids || !Array.isArray(ids)) {
                // Handle the case where elements or ids are not arrays or are undefined/null
                return [];
            }

            const names = [];

            for (const element of elements) {
                if (element && element.Id && ids.includes(element.Id)) {
                    names.push(element.Name);
                }
            }

            // instead of returning as array, returns a string where the items are separeted by coma ("1, 2, 3")
            return names.join(", ");
        },
        // Creates the object that will be sent to google tag manager data Layer
        createEvent(name, action, isUsed) {

            if (!this.filter)
                return;

            let analitycsProps = {
                'action': action,
                'isUsed': isUsed,
                'marca': this.getSelectedMarcas(),
                'modelo': this.getSelectedModels(),
                'ano_minimo': this.filter.YearStart,
                'ano_maximo': this.filter.YearEnd,
                'preco_minimo' : this.filter.PriceStart,
                'preco_maximo' : this.filter.PriceEnd,
                'kms_minimo': this.filter.KmStart,
                'kms_maximo' : this.filter.KmEnd,
                'cor': this.retrieveNamesByIds(this.colors, this.filter.ColorId),
                'combustivel': this.retrieveNamesByIds(this.fuels, this.filter.FuelId),
                'carrocaria': this.retrieveNamesByIds(this.bodyTypes, this.filter.BodyTypeId),
                'localizacao': this.retrieveNamesByIds(this.districts, this.filter.DistrictId),
                'pesquisa': this.filter.SearchTerm
            }

            tagManager.createEvent(name, analitycsProps)
        },
    },

    filters: {
        ToIconClass: Filters.ToIconClass
    },

    computed: {
        ColapsedClass() {
            return this.isCollapsed ? "collapse" : "";
        },
        ToggleMoreColapsedClass() {
            return this.isCollapsed ? "collapsed" : "";
        }
    }

};
</script>
